import { Button, Card,DatePicker, DatePickerProps, Form, Input, message, Select, Space,} from 'antd';
import React, { useState } from 'react';
import moment, { Moment } from "moment";
import { RangePickerProps } from 'antd/es/date-picker';
interface PropsType {
  doQuery: Function;
}

export const QueryPanel: React.FC<PropsType> = ({ doQuery }) => {
  const [checkDateBegin, setCheckDateBegin] = useState<string | undefined>(undefined);
  const [checkDateEnd, setCheckDateEnd] = useState<string | undefined>(undefined);
  const [ageBegin, setAgeBegin] = useState<string | undefined>(undefined);
  const [ageEnd, setAgeEnd] = useState<string | undefined>(undefined);
  const [schoolName, setSchoolName] = useState<string | undefined>(undefined);
  const [checkName, setCheckName] = useState<string | undefined>(undefined);
  const [cat, setCat] = useState<number[] | undefined>(undefined);
  const [result, setResult] = useState<number[] | undefined>(undefined);
  const [form] = Form.useForm();
  const onSubmit = ()=>{
    doQuery(checkDateBegin,checkDateEnd,ageBegin,ageEnd,schoolName,checkName,cat,result);
    let d = new Date();
    let Y = d.getFullYear();
    form.setFieldsValue({testDates:[moment(`${Y}-01-01`),moment(`${Y+1}-01-01`)]})
    setAgeBegin('0');
    setAgeEnd('12');
    setSchoolName('');
    setCheckName('');
    setCat([]);
    setResult([]);
  }
  const onSchoolChange = (e: any) => {
    setSchoolName(e.target.value);
  }
  const onAgeBeginChange = (e: any) => {
    /*let age = parseInt(e.target.value);
    if (isNaN(age)) {
      message.warning("开始年龄输入不合法!");
      setAgeBegin(undefined);
    } else {
      setAgeBegin(age);
    }*/
    setAgeBegin(e.target.value);
  }
  const onAgeEndChange = (e: any) => {
    /*let age = parseInt(e.target.value);
    if (isNaN(age)) {
      message.warning("结束年龄输入不合法!");
      setAgeEnd(undefined);
    } else {
      setAgeEnd(age);
    }*/
    setAgeEnd(e.target.value);
  }
  const onCatChange = (e: any) => {
    setCat(e);
  }
  const onResultChange = (e: any) => {
    setResult(e);
  }
  
  const onCheckerChange = (e: any) => {
    setCheckName(e.target.value);
  }
  /*const onCheckDateChange = (dates: any) => {
    setCheckDateBegin(moment(dates[0]).format("YYYY-MM-DD HH:mm:ss"));
    setCheckDateEnd(moment(dates[1]).format("YYYY-MM-DD HH:mm:ss"));
  };*/
  const onCheckDateChange=(
    value: DatePickerProps["value"] | RangePickerProps["value"],
    dateString: [string, string] | string
  ) => {
    if (dateString instanceof Array) {
      setCheckDateBegin(dateString[0]);
      setCheckDateEnd(dateString[1]);
    }
  };
  return (
    <>
        <Form
          layout="horizontal"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          form={form}
        >
          <Form.Item
            label='检测日期:'
            name="testDates"
          >
            <DatePicker.RangePicker onChange={onCheckDateChange} />
          </Form.Item>
          <Form.Item label='受检人年龄'>
            <Space direction="horizontal">
              <span>从</span>
              <Input onChange={onAgeBeginChange} value={ageBegin}/>
              <span>至</span>
              <Input onChange={onAgeEndChange} value={ageEnd} />
            </Space>
          </Form.Item>
          <Form.Item
            label='学校/幼儿园名称:'
          >
            <Input onChange={onSchoolChange} placeholder="请输入" value={schoolName}/>
          </Form.Item>
          <Form.Item
            label='检测人:'
          >
            <Input onChange={onCheckerChange} placeholder='请输入' value={checkName}/>
          </Form.Item>
          <Form.Item
            label='CAT值:'
          >
            <Select
              mode="multiple"
              allowClear
              onChange={onCatChange}
              value={cat}
            >
              <Select.Option key={0}>0</Select.Option>
              <Select.Option key={0.5}>0.5</Select.Option>
              <Select.Option key={1.0}>1.0</Select.Option>
              <Select.Option key={1.5}>1.5</Select.Option>
              <Select.Option key={2.0}>2.0</Select.Option>
              <Select.Option key={2.5}>2.5</Select.Option>
              <Select.Option key={3.0}>3.0</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label='患龋风险等级:'
          >
            <Select
              mode="multiple"
              allowClear
              onChange={onResultChange}
              value={result}
            >
              <Select.Option key={"高风险"}>高风险</Select.Option>
              <Select.Option key={"中风险"}>中风险</Select.Option>
              <Select.Option key={"低风险"}>低风险</Select.Option>
            </Select>
          </Form.Item>          
          <Form.Item>
            <Button size="large" type="primary" shape="round" htmlType="submit" onClick={onSubmit} >查询</Button>
          </Form.Item>
        </Form>  
    </>
  );
};